var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guest-layout"},[_c('heading-brand'),_vm._v(" "),_c('main',{staticClass:"container",attrs:{"role":"main"}},[_vm._t("default")],2),_vm._v(" "),(_vm.footer === true)?_c('footer-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }